import { render, staticRenderFns } from "./ClassFileUploader.vue?vue&type=template&id=8d26a6a8&scoped=true&"
import script from "./ClassFileUploader.vue?vue&type=script&lang=js&"
export * from "./ClassFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./ClassFileUploader.vue?vue&type=style&index=0&id=8d26a6a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d26a6a8",
  null
  
)

export default component.exports